import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { UserSliceProp } from '../../../types/user.types'
import { LoginMockProps } from '../../../types/auth.types'

const initialState: UserSliceProp = {
  user: null
}

const userSlice = createSlice({
  initialState,
  name: 'user',
  reducers: {
    resetUser: () => initialState,
    setUser: (state, { payload }: PayloadAction<LoginMockProps>) => {
      state.user = payload
    }
  }
})

export const { resetUser, setUser } = userSlice.actions
export default userSlice.reducer
